export default __webpack_public_path__ + "static/media/InertiaExImg.65be3529.jpg";